const phishing = {
  en: {
    translation: {
      domain: "Domain",
      url: "URL",
      path: "Path",
      first_seen: "First seen",
      last_seen: "Last seen",
      victim_name: "Victim",
      victim_nation: "Victim country",
      geo_location: "Location",
      details: "Details",
      nameservers: "Nameservers",
      ip: "IP",
      asn: "ASN",
      tls_issuer: "TLS certificate issuer",
      tls_validity: "TLS certificate validity",
      dom_hash: "DOM hash",
      text_hash: "Text hash",
      title: "Title",
      description: "Description",
      intelligence: "Intelligence",
      favicon: "Favicon",
      screenshot: "Screenshot",
      page_description: "Impersonation or imitation of your brand for malicious purposes.",
      website_status: "Takedown status",
      website_status_active: "Not initiated",
      website_status_in_progress: "In progress",
      website_status_disabled: "Done",
      managed_phishing: "Managed phishing",
      manage: "Mark as managed",
      managed: "You have already seen this",
      not_managed_yet: "You have not managed this yet",
      askTakedown: "Ask takedown",
      takedownRequested: "Takedown requested on ",
      takedown_status_none: "None",
      takedown_status_requested: "Requested",
      takedown_status_taken_down: "Taken down",
      takedown_status_false_positive: "False positive",
      takedown_status_failed: "Failed",
      takedown_status_not_processable: "Not processable",
      update_takedown_status: "Update takedown status",
      record_updated: "Record updated",
      record_updated_text: "The record has been updated successfully",
      add_to_whitelist: "Add to whitelist",
      remove_from_whitelist: "Remove from whitelist",
    },
  },
  it: {
    translation: {
      domain: "Dominio",
      url: "URL",
      path: "Percorso",
      first_seen: "Primo rilevamento",
      last_seen: "Ultimo rilevamento",
      victim_name: "Vittima",
      victim_nation: "Paese vittima",
      geo_location: "Localizzazione",
      details: "Dettagli",
      nameservers: "Nameservers",
      ip: "IP",
      asn: "ASN",
      tls_issuer: "Emittente certificato TLS",
      tls_validity: "Validità certificato TLS",
      dom_hash: "Hash DOM",
      text_hash: "Hash testo",
      title: "Titolo",
      description: "Descrizione",
      intelligence: "Intelligence",
      favicon: "Favicon",
      screenshot: "Screenshot",
      page_description: "Impersonificazione o imitazione del vostro brand a fini malevoli",
      website_status: "Stato takedown",
      website_status_active: "Non iniziato",
      website_status_in_progress: "In corso",
      website_status_disabled: "Completato",
      managed_phishing: "Phishing gestito",
      manage: "Segna come gestito",
      managed: "Già visto",
      not_managed_yet: "Non lo hai ancora gestito",
      askTakedown: "Richiedi takedown",
      takedownRequested: "Takedown richiesto il ",
      takedown_status_none: "Nessuno",
      takedown_status_requested: "Richiesto",
      takedown_status_taken_down: "Abbattuto",
      takedown_status_false_positive: "Falso positivo",
      takedown_status_failed: "Fallito",
      takedown_status_not_processable: "Non processabile",
      update_takedown_status: "Aggiorna stato takedown",
      record_updated: "Riga aggiornata",
      record_updated_text: "Il record è stato aggiornato con successo",
      add_to_whitelist: "Aggiungi alla whitelist",
      remove_from_whitelist: "Rimuovi dalla whitelist",
    },
  },
};

export default phishing;
